import { shape, object } from 'prop-types';
import React, { Fragment } from 'react';
import Head from 'next/head';
import AmpAd from 'components/AmpAd';
import { BASE_AD_UNITS_AMP } from 'constants/ads/units';

function AmpStickyAd({ post }) {
  return (
    <Fragment>
      <Head>
        <script
          async
          key="amp-sticky-ad"
          custom-element="amp-sticky-ad"
          src="https://cdn.ampproject.org/v0/amp-sticky-ad-1.0.js"
        />
      </Head>
      <amp-sticky-ad layout="nodisplay">
        <AmpAd
          size={[320, 50]}
          unit={`${BASE_AD_UNITS_AMP.post}/Sticky`}
          targeting={post.data.ads.targeting}
          resourceId={post.data.resourceId}
          refreshInterval={30}
        />
      </amp-sticky-ad>
    </Fragment>
  );
}

AmpStickyAd.propTypes = {
  post: shape({
    ads: shape({
      targeting: object
    })
  }).isRequired
};

export default AmpStickyAd;
